import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";

const CursiveTextGenerator = () => {
  const [inputText, setInputText] = useState(""); // User input text
  const [cursiveText, setCursiveText] = useState(""); // Cursive output

  // Mapping of regular characters to their cursive Unicode equivalents
  const toCursive = (text) => {
    const cursiveMap = {
      a: "𝒶", b: "𝒷", c: "𝒸", d: "𝒹", e: "𝑒", f: "𝒻", g: "𝑔",
      h: "𝒽", i: "𝒾", j: "𝒿", k: "𝓀", l: "𝓁", m: "𝓂", n: "𝓃",
      o: "𝑜", p: "𝓅", q: "𝓆", r: "𝓇", s: "𝓈", t: "𝓉", u: "𝓊",
      v: "𝓋", w: "𝓌", x: "𝓍", y: "𝓎", z: "𝓏",
      A: "𝒜", B: "𝐵", C: "𝒞", D: "𝒟", E: "𝐸", F: "𝐹", G: "𝒢",
      H: "𝐻", I: "𝐼", J: "𝒥", K: "𝒦", L: "𝐿", M: "𝑀", N: "𝒩",
      O: "𝒪", P: "𝒫", Q: "𝒬", R: "𝑅", S: "𝒮", T: "𝒯", U: "𝒰",
      V: "𝒱", W: "𝒲", X: "𝒳", Y: "𝒴", Z: "𝒵",
    };

    return text
      .split("")
      .map((char) => cursiveMap[char] || char)
      .join("");
  };

  // Handle text conversion
  const handleGenerate = () => {
    if (!inputText.trim()) {
      toast.error("Please enter text to convert!", {
        position: "top-center",
      });
      return;
    }

    setCursiveText(toCursive(inputText));
    toast.success("Cursive text generated successfully!", {
      position: "top-center",
    });
  };

  // Handle copying the result
  const handleCopy = () => {
    if (!cursiveText) {
      toast.error("Nothing to copy! Generate cursive text first.", {
        position: "top-center",
      });
      return;
    }

    navigator.clipboard.writeText(cursiveText);
    toast.success("Cursive text copied to clipboard!", {
      position: "top-center",
    });
  };

  return (
    <div className="container mt-5">
      <ToastContainer />
      <h2 className="text-center mb-4">Cursive Text Generator</h2>

      <div className="row justify-content-center">
        <div className="col-md-8 col-12">
          {/* Input Section */}
          <div className="mb-3">
            <textarea
              className="form-control"
              rows="4"
              placeholder="Enter your text here..."
              value={inputText}
              onChange={(e) => setInputText(e.target.value)}
            ></textarea>
          </div>

          {/* Buttons */}
          <div className="d-grid gap-2">
            <button className="btn btn-primary" onClick={handleGenerate}>
              Generate Cursive Text
            </button>
          </div>
        </div>
      </div>

      {/* Output Section */}
      {cursiveText && (
        <div className="row justify-content-center mt-4">
          <div className="col-md-8 col-12">
            <div className="output p-3 border rounded bg-light text-center">
              <h4>Your Cursive Text:</h4>
              <div className="text-center">
              <p className="p-3 bg-white">{cursiveText}</p>
              </div>
              <button className="btn btn-success mt-2" onClick={handleCopy}>
                Copy to Clipboard
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CursiveTextGenerator;
